import { render, staticRenderFns } from "./EventModalPassesActions.vue?vue&type=template&id=6f530140&scoped=true"
import script from "./EventModalPassesActions.vue?vue&type=script&lang=js"
export * from "./EventModalPassesActions.vue?vue&type=script&lang=js"
import style0 from "./EventModalPassesActions.vue?vue&type=style&index=0&id=6f530140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f530140",
  null
  
)

export default component.exports